import Userdashboard from "../components/dashboard/Userdashboard";
import Navbar from "../components/Navbar/Navbar";


const DashboardPage = () => {
    return ( 
        <>
        <Navbar/>
        <Userdashboard/>
        </>
     );
}
 
export default DashboardPage;